import React from "react";
const RequestToQuote = () => {
  return <div className="container pt-6 pb-10 bg-white" data-sentry-component="RequestToQuote" data-sentry-source-file="index.tsx">
      <a href="/request-quote.html" data-testid="request-to-quote" className="relative block w-full bg-gray-50 border border-solid border-gray-200 overflow-hidden rounded">
        <div className="absolute top-0 left-0 hidden sm:block">
          <img src="uploads/design/2023/3/request-a-quote-desktop.png" alt="Request to Quote Logo" loading="lazy" style={{
          width: "173px"
        }} />
        </div>
        <div className="absolute bottom-0 right-0 block sm:hidden">
          <img src="uploads/design/2023/3/request-a-quote-mobile.png" alt="Request to Quote Logo" loading="lazy" style={{
          width: "143px"
        }} />
        </div>
        <div className="relative flex flex-row justify-start xsl:justify-center md:justify-between items-center px-5 py-3 pr-0 lg:py-5 space-x-12 sm:space-x-6" style={{
        justifyContent: "start"
      }}>
          <div className="flex flex-col sm:flex-row sm:justify-between w-auto sm:w-full sm:space-x-8 pr-4">
            <div className="max-w-2xs xs:max-w-sm sm:max-w-none ml-0 sm:ml-40 md:ml-52 mb-2 sm:mb-0">
              <p className="text-sm lg:text-lg font-normal leading-none text-gray-900 mb-1 lg:mb-0">
                Have a large list of items?
              </p>
              <h2 className="text-2xl font-bold leading-none text-gray-900 mb-1">
                Get a personalized quote just for you.
              </h2>
            </div>
            <div className="inline-flex justify-start items-center lg:mr-12 flex-none">
              <div className="bg-green-500 hover:bg-green-900 transition-all ease-in duration-100 border-transparent px-5 py-2 rounded text-white font-normal text-base leading-none">
                Request a Quote
              </div>
            </div>
            <div className="w-56 h-auto ml-4 sm:hidden" />
          </div>
        </div>
      </a>
    </div>;
};
export default RequestToQuote;